<template>
  <div class="ContactUs">
    <!-- banner -->
    <div style="width: 100%; position: relative">
      <img
        style="width: 100%; height: 100%"
        src="@/images/joinus/about.png"
        alt=""
      />
      <div
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <span style="display: flex; align-items: center">
          <!-- <img
            style="
              font-size: 0;
              width: 0.36rem;
              height: 0.36rem;
              margin-right: 12px;
            "
            src="@/images/common/iconblue.png"
            alt=""
          /> -->
          <span class="txt">联系我们</span>
        </span>
      </div>
    </div>
    <div class="warper" style="overflow: hidden">
      <div class="box">
        <div class="">
          <div class="flexs align-items" style="margin-bottom: 82px">
            <!-- <img
              style="width: 40px; height: 40px; font-size: 0"
              src="@/images/icon/KJY_yuan1.png"
              alt=""
            /> -->
            <div class="title">联系我们</div>
          </div>
          <div class="left">
            <div class="flexs align-items" style="margin-bottom: 40px">
              <img src="@/images/icon/address.png" alt="" />
              <p>宁波市鄞州区明楼街道柴家漕巷27号 供销大厦13楼</p>
            </div>
            <div class="flexs align-items" style="margin-bottom: 40px">
              <img src="@/images/icon/phone.png" alt="" />
              <p>400-0574-222</p>
            </div>
            <div class="flexs align-items" style="margin-bottom: 40px">
              <img src="@/images/icon/e-meil.png" alt="" />
              <p>chris@caton-logistics.com</p>
            </div>
          </div>
          <div class="right"></div>
        </div>
        <!-- 百度地图 -->
        <baidu-map
          class="map"
          :center="markerPoint1"
          :zoom="20"
          :scroll-wheel-zoom="false"
        >
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <!-- 遍历多个点坐标 -->
          <template v-for="(items, index) in str">
            <bm-marker
              :key="index"
              :position="items.markerPoint"
              @click="lookDetail(items)"
            >
            </bm-marker>
          </template>
          <!-- 信息窗体 -->
          <!-- <bm-info-window
            :position="position"
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
          >
            <p>{{ from.xianghao }}</p>
            <p>{{ from.adds }}</p>
            <p>{{ from.time }}</p>
            <el-button type="text">详情</el-button>
          </bm-info-window> -->
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FromItem",
  data() {
    return {
      position: {},
      //   show: false,
      markerPoint1: { lng: 121.580062, lat: 29.889058 },
      from: {},
      str: [
        {
          markerPoint: { lng: 121.580062, lat: 29.889058 },
          xianghao: "BADWQI32221",
          adds: "差分状态:N",
          time: "上报时间:2020/11/01 13:48",
        },
        // {
        //   markerPoint: { lng: 113.52, lat: 31.67 },
        //   xianghao: "ABCD873873",
        //   adds: "差分状态:Y",
        //   time: "上报时间:2020/11/23 13:48",
        // },
        // {
        //   markerPoint: { lng: 116.404, lat: 39.915 },
        //   xianghao: "EERQSIA21",
        //   adds: "差分状态:N",
        //   time: "上报时间:2018/11/23 11:48",
        // },
      ],
    };
  },
  methods: {
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
    lookDetail(items) {
      console.log(items);
      this.from = items;
      this.position = items.markerPoint;
      this.show = true;
    },
  },
};
</script>

<style scoped>
.ContactUs {
  width: 100%;
  background: #f6f7f9;
}
.warper {
  width: 10rem;
  margin: 0 auto;
  overflow: hidden;
}
.txt {
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.box {
  /* padding: 30px 74px 68px;
  background: #ffffff;
  box-shadow: 0px 4px 18px 0px rgba(221, 222, 224, 0.85); */
  margin: 80px 0;
  overflow: hidden;
}
.box .left {
  /* margin-left: 52px; */
}
.title {
  margin-left: 12px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f7841e;
}
.flexs {
  display: flex;
}
.flexs span {
  font-size: 18px;
  color: #e9730b;
  margin-right: 10px;
}
.flexs img {
  width: 36px;
  height: 36px;
  font-size: 0;
}
.flexs p {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(22, 23, 24, 0.8);
  line-height: 28px;
  margin-left: 16px;
}
.el-icon-phone:before {
  color: #e9730b;
}
.align-items {
  align-items: center;
}
.jbs {
  justify-content: space-between;
}
.map {
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs/index.vue